import { Check, ChevronRight } from "lucide-react";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { Button } from "@/components/ui/button";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import FilterLabel from "./FilterLabel";
import { useSearchStore } from "@/stores/SearchStore";

function FilterButton({ filterKeys, label, urlName }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const filterKeyExists = filterKeys.some((key) =>
    searchParams.has(urlName, key)
  );
  const [checked, setChecked] = useState(filterKeyExists);

  // Reset selectedFilter when urlName is removed from searchParams
  useEffect(() => {
    if (!searchParams.has(urlName)) {
      setChecked(false);
    }
  }, [searchParams, urlName]);

  function setAllSearchParams() {
    setSearchParams(searchParams);
    useSearchStore.setState({ searchPageSearchParams: searchParams });
  }

  function onClicked() {
    if (!checked) {
      filterKeys.forEach((key) => {
        searchParams.append(urlName, key);
      });
    } else {
      filterKeys.forEach((key) => {
        searchParams.delete(urlName, key);
      });
    }
    setChecked(!checked);
    setAllSearchParams();
  }
  return (
    <Button
      variant={checked ? "default" : "secondary"}
      size="sm"
      //   className={`w-full justify-start `}
      onClick={onClicked}
    >
      {checked && <Check className="" />}
      {label}
    </Button>
  );
}

export function CollapsibleFilter({
  title,
  items,
  urlName,
  defaultOpen = true,
}) {
  return (
    <div>
      <Collapsible defaultOpen={defaultOpen} className="group/collapsible">
        <CollapsibleTrigger asChild>
          <Button
            variant="link"
            className="w-full justify-between text-background-foreground "
          >
            <FilterLabel className="-ml-4">{title}</FilterLabel>
            <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="flex flex-wrap gap-2">
          {items?.map((item) => (
            <FilterButton
              key={item?.label || item}
              filterKeys={item?.keys || [item]}
              label={item?.label || item}
              urlName={urlName}
            />
          ))}
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
}
